import React from 'react'
import ffffff from '../image/ffffff.avif'
import { styled } from '@mui/system'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import Typography from '@mui/material/Typography'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

const useStyles = styled((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}))
function AAd_FAQ_page() {
  return (
    <div>
      <div className="mt-5">
        <div className="container pt-3">
          <div className="text-center Curriculum_Main_text">
            <div className="">
              <h2 className="display-6">Frequently Asked Questions</h2>
              <p className="pt-2">
                Our Responses to Your Inquiries: Unblocking the Way to Clarity
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-5">
              <div className="FAQ_img">
                <img
                  src={ffffff}
                  onContextMenu={(e) => e.preventDefault()}
                ></img>
              </div>
            </div>
            <div className="col-md-7 pt-5 d-none d-md-block">
              <div className="pt-5">
                <div className="pt-5">
                  <div className="pt-5">
                    <AAD_FAQ />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-12 d-sm-block d-md-none mb-5">
              <AAD_FAQ />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

function AAD_FAQ() {
  const classes = useStyles()
  const [expanded, setExpanded] = React.useState(false)

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false)
  }

  return (
    <>
      <div className={classes.root}>
        <Accordion
          className="py-2"
          expanded={expanded === 'panel1'}
          onChange={handleChange('panel1')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
            className="FAQ_background_color"
          >
            <Typography style={{ fontSize: '1.2rem' }}>
              What programming languages should I learn for Android development?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              The primary languages for Android development are Java and Kotlin.
              Java has been the traditional language for Android apps, but
              Kotlin is now the preferred language due to its modern features
              and concise syntax. Learning XML for designing layouts is also
              essential.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          className="py-2"
          expanded={expanded === 'panel2'}
          onChange={handleChange('panel2')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2bh-content"
            id="panel2bh-header"
            className="FAQ_background_color"
          >
            <Typography style={{ fontSize: '1.2rem' }}>
              What tools and frameworks are commonly used in Android
              development?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              Developers typically use Android Studio, the official Integrated
              Development Environment (IDE) for Android development. Other tools
              include Gradle for build automation, Android Jetpack components
              for architecture, and libraries like Retrofit for networking and
              Glide for image loading.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          className="py-2"
          expanded={expanded === 'panel3'}
          onChange={handleChange('panel3')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel3bh-content"
            id="panel3bh-header"
            className="FAQ_background_color"
          >
            <Typography style={{ fontSize: '1.2rem' }}>
              How do I get started with Android app development?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              To start, you should familiarize yourself with the basics of Java
              or Kotlin. Then, set up Android Studio and go through official
              tutorials on the Android Developer website. Building simple apps
              and gradually increasing complexity will help reinforce your
              learning.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          className="py-2"
          expanded={expanded === 'panel4'}
          onChange={handleChange('panel4')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel4bh-content"
            id="panel4bh-header"
            className="FAQ_background_color"
          >
            <Typography style={{ fontSize: '1.2rem' }}>
              What are the key skills needed to be a successful Android
              developer?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              Apart from programming languages, key skills include understanding
              the Android application lifecycle, user interface design
              principles, RESTful APIs, version control systems (like Git), and
              testing frameworks. Familiarity with Firebase or other backend
              services is also beneficial.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          className="py-2"
          expanded={expanded === 'panel5'}
          onChange={handleChange('panel5')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel5bh-content"
            id="panel5bh-header"
            className="FAQ_background_color"
          >
            <Typography style={{ fontSize: '1.2rem' }}>
              How can I improve my job prospects in Android development?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              Building a portfolio of projects is crucial, as it showcases your
              skills to potential employers. Contributing to open-source
              projects, participating in hackathons, and keeping up with the
              latest Android trends and updates can also enhance your visibility
              in the job market. Networking through platforms like LinkedIn and
              joining developer communities can further improve your job
              prospects.
            </Typography>
          </AccordionDetails>
        </Accordion>
      </div>
    </>
  )
}

export default AAd_FAQ_page
